var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warming-tray time-block ",style:({left: _vm.xPosition + '%',  width : _vm.width + '%', 'min-height' : (_vm.Unit.height - 3) + 'px'})})}
var staticRenderFns = []

export { render, staticRenderFns }